/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const UPGRADE_ROLE = gql`
mutation UpgradeRoleToMinter {
    upgradeRoleToMinter {
      access_token
      user {
        email
        givenName
        familyName
        fullName
        emailVerified
        isRegistered
        isInviEmailSent
        isWalletRegistered
        chainId
        role {
          _id
          name
          permissions {
            subject
            action
            inverted
            fields
          }
        }
        brand {
          _id
          telephone
          sameAs
          description
          name
          email
          creator
          address {
            addressLine1
            addressLine2
            city
            state
            zipcode
            country
          }
          fullAddress
          logo
          createdAt
          updatedAt
          OrgType
          isWalletRegistered
          chainId
          walletAddress
          type
          supportedChainId
          country
          platform_fee
          brokerage
          paymentOptions {
            paymentEnabled
            KYCSubmitted
            provider
            account
          }
          supportedCurrencies
        }
      }
    }
  }
`;